var $9fb7f7fd655cfe7d$exports = {};
const $9fb7f7fd655cfe7d$var$explainer = document.querySelector(".explainer");
if ($9fb7f7fd655cfe7d$var$explainer) {
    let descriptions = [
        {
            description: "niski wzrost \u2013 do 130 cm",
            x: -0.2,
            y: -0.01,
            to: 'always-right'
        },
        {
            description: "zwi\u0119kszenie obwodu g\u0142owy",
            x: 0.63,
            y: 0.07
        },
        {
            description: "zaw\u0119\u017Cenie podstawy czaszki",
            x: 0.24,
            y: 0.28
        },
        {
            description: "nadmierne uwypuklenie czo\u0142a",
            x: 0.39,
            y: 0.13
        },
        {
            description: "zapadni\u0119cie nasady nosa",
            x: 0.4,
            y: 0.16
        },
        {
            description: "skrzywienie kr\u0119gos\u0142upa",
            x: 0.7,
            y: 0.28
        },
        {
            description: "ko\u015Blawo\u015B\u0107 n\xf3g",
            x: 0.6,
            y: 0.8
        },
        {
            description: "zw\u0119\u017Cenie klatki piersiowej",
            x: 0.45,
            y: 0.4
        },
        {
            description: "problemy z oddychaniem",
            x: 0.45,
            y: 0.35
        },
        {
            description: "zwi\u0119kszona ruchomo\u015B\u0107 staw\xf3w",
            x: 0.85,
            y: 0.45
        },
        {
            description: "obni\u017Cenie napi\u0119cia mi\u0119\u015Bniowego",
            x: 0.05,
            y: 0.35
        },
        {
            description: "przykurcze staw\xf3w",
            x: 0.1,
            y: 0.6
        },
        {
            description: "bardzo kr\xf3tkie palce",
            x: 0.12,
            y: 0.55
        },
        {
            description: "cz\u0119ste infekcje ucha \u015Brodkowego i zwi\u0105zany z tym niedos\u0142uch",
            x: 0.12,
            y: 0.2
        },
        {
            description: "wodog\u0142owie (u niekt\xf3rych pacjent\xf3w), konieczno\u015B\u0107 odprowadzenia p\u0142ynu",
            x: 0.53,
            y: 0.04
        }
    ];
    let imageElement = $9fb7f7fd655cfe7d$var$explainer.getElementsByTagName('img')[0];
    let dotsElement = $9fb7f7fd655cfe7d$var$explainer.querySelector('.dots');
    window.addEventListener('resize', ()=>{
        dotsElement.style.left = imageElement.offsetLeft.toString() + 'px';
        dotsElement.style.top = imageElement.offsetTop + 'px';
        dotsElement.style.width = imageElement.width + 'px';
        dotsElement.style.height = imageElement.height + 'px';
    });
    descriptions.forEach((item)=>{
        let tpl = `<div class="point"></div><div class="description"><p>${item.description}</p></div>`;
        let newEl = document.createElement('div');
        newEl.classList.add('dot');
        newEl.style.left = (item.x * 100).toString() + '%';
        newEl.style.top = (item.y * 100).toString() + '%';
        newEl.innerHTML = tpl;
        if (item.x < 0.5) newEl.classList.add('to-left');
        if (item.to) {
            if (item.to == 'left') newEl.classList.add('to-left');
            else newEl.classList.remove('to-left');
            if (item.to == 'always-right') newEl.classList.add('always-right');
        }
        $9fb7f7fd655cfe7d$var$explainer.getElementsByClassName('dots')[0].appendChild(newEl);
    });
}
const $9fb7f7fd655cfe7d$var$childhoodBlock = document.querySelector(".b-Childhood");
if ($9fb7f7fd655cfe7d$var$childhoodBlock) {
    let childHeading = $9fb7f7fd655cfe7d$var$childhoodBlock.querySelector('h2');
    let childScrollHandler = ()=>{
        if (childHeading.getBoundingClientRect().top < 2 * window.innerHeight / 3) {
            $9fb7f7fd655cfe7d$var$childhoodBlock.classList.add('visible');
            document.querySelector('.welcome-box__scroll-down').classList.add('hidden');
            setTimeout(()=>{
                document.querySelector('.welcome-box__scroll-down').remove();
            }, 2000);
            window.removeEventListener('scroll', childScrollHandler);
        }
    };
    window.addEventListener('scroll', childScrollHandler);
}
const $9fb7f7fd655cfe7d$var$heightBlock = document.querySelector(".b-Height");
if ($9fb7f7fd655cfe7d$var$heightBlock) {
    let heightContainer = $9fb7f7fd655cfe7d$var$heightBlock.querySelector('.container');
    let hcTop = (window.outerHeight - heightContainer.getBoundingClientRect().height) / 2;
    heightContainer.style.top = hcTop.toString() + 'px';
    let heightScrollHandler = ()=>{
        if ($9fb7f7fd655cfe7d$var$heightBlock.getBoundingClientRect().top < 0) {
            $9fb7f7fd655cfe7d$var$heightBlock.classList.add('visible');
            if ($9fb7f7fd655cfe7d$var$heightBlock.getBoundingClientRect().bottom - heightContainer.getBoundingClientRect().bottom <= 141 && heightContainer.getBoundingClientRect().top <= hcTop + 1) {
                $9fb7f7fd655cfe7d$var$heightBlock.classList.remove('fixed');
                $9fb7f7fd655cfe7d$var$heightBlock.classList.add('bottomed');
                heightContainer.style.top = 'auto';
            } else {
                $9fb7f7fd655cfe7d$var$heightBlock.classList.add('fixed');
                $9fb7f7fd655cfe7d$var$heightBlock.classList.remove('bottomed');
                heightContainer.style.top = hcTop.toString() + 'px';
            }
        } else $9fb7f7fd655cfe7d$var$heightBlock.classList.remove('fixed');
    };
    window.addEventListener('scroll', heightScrollHandler);
}
const $9fb7f7fd655cfe7d$var$europeBlock = document.querySelector(".b-Europe");
if ($9fb7f7fd655cfe7d$var$europeBlock) {
    let europeScrollHandler = ()=>{
        if ($9fb7f7fd655cfe7d$var$europeBlock.getBoundingClientRect().top < window.innerHeight / 4) {
            $9fb7f7fd655cfe7d$var$europeBlock.classList.add('visible');
            window.removeEventListener('scroll', europeScrollHandler);
        }
    };
    window.addEventListener('scroll', europeScrollHandler);
    let imgElement = $9fb7f7fd655cfe7d$var$europeBlock.querySelector('.b-Europe__image');
    let imgBaseWidth = 812;
    let imgBaseHeight = 521;
    let imgRatio = 1.56;
    let imgPath = imgElement.querySelector('svg g');
    let europeResizeHandler = ()=>{
        console.log(imgElement.getBoundingClientRect().height / imgElement.getBoundingClientRect().width);
        if (imgElement.getBoundingClientRect().width / imgElement.getBoundingClientRect().height > imgRatio) {
            let transformScaleRatio = imgElement.getBoundingClientRect().width / 812;
            imgPath.style.transform = 'scale(' + transformScaleRatio + ') translateY(' + (imgElement.getBoundingClientRect().height - 521 * transformScaleRatio) / 2 + 'px)';
        } else {
            let transformScaleRatio = imgElement.getBoundingClientRect().height / 521;
            imgPath.style.transform = 'scale(' + transformScaleRatio + ') translateX(' + ((imgElement.getBoundingClientRect().width - 812 * transformScaleRatio) / 2 + 200) + 'px)';
        }
    };
    window.addEventListener('resize', europeResizeHandler);
}
const $9fb7f7fd655cfe7d$var$everydayBlock = document.querySelector(".b-EveryDay");
if ($9fb7f7fd655cfe7d$var$everydayBlock) {
    let everydayScrollHandler = ()=>{
        if ($9fb7f7fd655cfe7d$var$everydayBlock.getBoundingClientRect().top < window.innerHeight / 2) {
            $9fb7f7fd655cfe7d$var$everydayBlock.classList.add('visible');
            window.removeEventListener('scroll', everydayScrollHandler);
        }
    };
    window.addEventListener('scroll', everydayScrollHandler);
}
const $9fb7f7fd655cfe7d$var$understandingBlock = document.querySelector(".b-Understanding");
if ($9fb7f7fd655cfe7d$var$understandingBlock) {
    let understandingScrollHandler = ()=>{
        if ($9fb7f7fd655cfe7d$var$understandingBlock.getBoundingClientRect().top < window.innerHeight / 4) {
            $9fb7f7fd655cfe7d$var$understandingBlock.classList.add('visible');
            window.removeEventListener('scroll', understandingScrollHandler);
        }
    };
    window.addEventListener('scroll', understandingScrollHandler);
}
const $9fb7f7fd655cfe7d$var$blocks = document.querySelectorAll('section');
const $9fb7f7fd655cfe7d$var$headerLinks = document.querySelector('.p-header-nav');
let $9fb7f7fd655cfe7d$var$currentElId = null;
const $9fb7f7fd655cfe7d$var$blockPositionChecker = ()=>{
    let newCurrentElId = null;
    $9fb7f7fd655cfe7d$var$blocks.forEach((blockElement)=>{
        if (blockElement.getBoundingClientRect().top < window.innerHeight / 2 && blockElement.getBoundingClientRect().bottom > window.innerHeight / 2) newCurrentElId = blockElement.id;
    });
    if (newCurrentElId != $9fb7f7fd655cfe7d$var$currentElId) {
        const oldActiveNavEl = $9fb7f7fd655cfe7d$var$headerLinks.querySelector('a[href=\'#' + $9fb7f7fd655cfe7d$var$currentElId + '\']');
        if (oldActiveNavEl) oldActiveNavEl.classList.remove('active');
        const newActiveNavEl = $9fb7f7fd655cfe7d$var$headerLinks.querySelector('a[href=\'#' + newCurrentElId + '\']');
        if (newActiveNavEl) newActiveNavEl.classList.add('active');
        $9fb7f7fd655cfe7d$var$currentElId = newCurrentElId;
    }
};
$9fb7f7fd655cfe7d$var$headerLinks.querySelectorAll('a').forEach((el)=>{
    el.addEventListener('click', ()=>{
        $9fb7f7fd655cfe7d$var$headerLinks.parentElement.querySelector('input').checked = false;
    });
});
window.addEventListener('scroll', $9fb7f7fd655cfe7d$var$blockPositionChecker);
window.dispatchEvent(new Event('resize'));
window.dispatchEvent(new Event('scroll'));


//# sourceMappingURL=landing.5261b295.js.map
